import { getPushPublicKey, registerPushSubscription } from '@/shared/api';

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) {
    output[i] = raw.charCodeAt(i);
  }
  return output;
}

export async function ensureBrowserPush(userId: string): Promise<void> {
  if (!userId || !('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    return;
  }

  let permission = Notification.permission;
  if (permission === 'default') {
    if (sessionStorage.getItem('datacord.push.asked')) return;
    sessionStorage.setItem('datacord.push.asked', '1');
    permission = await Notification.requestPermission();
  }
  if (permission !== 'granted') return;

  const registration = await navigator.serviceWorker.register('/notification-sw.js');
  const publicKey = await getPushPublicKey();
  if (!publicKey) return;

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey) as BufferSource,
    });
  }

  await registerPushSubscription(userId, subscription.toJSON());
}
